<div class="grid grid-cols-[minmax(0,1fr)_8rem] gap-2">
  <mat-form-field appearance="outline">
    <mat-label>{{ label() }}</mat-label>
    <input
      matInput
      [matDatepicker]="picker"
      [value]="date()"
      [disabled]="disabled()"
      (dateChange)="dateChanged($event.value)"
      (blur)="touched()" />
    <mat-datepicker-toggle matIconSuffix [for]="picker" [disabled]="disabled()"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Time</mat-label>
    <input
      matInput
      type="time"
      step="300"
      [value]="time()"
      [disabled]="disabled()"
      (input)="timeChanged($any($event.target).value)"
      (blur)="touched()" />
  </mat-form-field>
</div>
